import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';
import { del, get, post, patch } from "../../api/api";

// Listar classificacoes
export const listarClassicacoes = async () => {
  return await get<IRespostaFuncao<any[]>>(`/classificacoes/obtem-classificacao`);
};

// Criar classificacao
export const criarClassificacao = async (
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await post<IRespostaFuncao<any>>(
    `/classificacoes/cria-classificacao`,
    payload
  );
};

// Atualizar classificacao
export const atualizarClassificacao = async (
  classificacaoId: string,
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(
    `/classificacoes/${classificacaoId}/atualiza-classificacao`,
    payload
  );
};

// Deletar classificacao
export const deletarClassificacao = async (
  classificacaoId: string
): Promise<IRespostaFuncao<any>> => {
  return await del<IRespostaFuncao<any>>(
    `/classificacoes/${classificacaoId}/remove-classificacao`
  );
};
